import { MenuItem } from "presentation/view/components/OverflowMenuButton";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";
import { GroupRadioList } from "veronica-ui-component/dist/component/core/GroupRadioButton/GroupRadioButton";
import { ConstraintDefEntity } from "domain/entity/Criteria/ConstraintDefEntity";
import { EMPTY_MARL_TYPE_EXCL_ENTITY, MarshallingTypeExclusionEntity } from "domain/entity/MarshallingTypeExclusion/MarshallingTypeExclusionEntity";

export interface EmptyExclCriteriaDropdownOptions {
    
    chargeOnCompanyDropdownOptions: DropdownProps[],
    marshallingTypeDropdownOptions: DropdownProps[],

}
export interface EmptyExclCriteriaChangeState extends BaseViewChangeSate {
    editingCriteriaEntity: MarshallingTypeExclusionEntity,
}

export interface MarshallingTypeExclusionModel {
    isLoading: boolean,
    isShowDetail: boolean,
    isShowCriteriaPanel: boolean,
    criteriaEntityList: MarshallingTypeExclusionEntity[],
    currentSelectedRow: MarshallingTypeExclusionEntity,
    selectedRows: MarshallingTypeExclusionEntity[],
    dynamicOptions: EmptyExclCriteriaDropdownOptions,
    isBackFromDetail: boolean,
    subMenuItemArray: MenuItem[],
    isShowMoveToPanel: boolean,
    masterState: EmptyExclCriteriaChangeState,
    entrypoint:string,
    chargeTypes?:  string[] | null,
    subChargeTypes?:  string[] | null,
    consGrpsTypeDropdownOptions: GroupRadioList[],
    allConstraintDef:ConstraintDefEntity[],
}

export const EMPTY_MARL_TYPE_EXCL_MODEL: MarshallingTypeExclusionModel = {
    isLoading: false,
    isShowDetail: false,
    isShowCriteriaPanel: false,
    criteriaEntityList: [],
    currentSelectedRow: { ...EMPTY_MARL_TYPE_EXCL_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        chargeOnCompanyDropdownOptions: [],
        marshallingTypeDropdownOptions: [],
    },
    isBackFromDetail: false,
    subMenuItemArray: [],
    isShowMoveToPanel: false,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        editingCriteriaEntity: EMPTY_MARL_TYPE_EXCL_ENTITY
    },
    entrypoint:"",
    chargeTypes: [],
    subChargeTypes: [],
    consGrpsTypeDropdownOptions: [],
    allConstraintDef: [],
}